<template>
    <!-- Spec §5: shown while a system admin works in a company they are not a member of. -->
    <div
        v-if="company?.admin_mode"
        role="status"
        class="shrink-0 flex items-center gap-2 px-4 sm:px-6 py-2 text-sm font-medium bg-warning/15 text-warning border-b border-default"
    >
        <UIcon name="i-lucide-shield-alert" class="size-4 shrink-0" />
        <span class="min-w-0">{{ $t('admin_mode.bar', { company: company.legal_name }) }}</span>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'

    import { useCompanyStore } from '@/stores/company'

    const companyStore = useCompanyStore()
    const company      = computed(() => companyStore.company)
</script>
